/** @module csi/skintheme/Spearmint */
define([], function() {
	return {
		Blue1: "Green30",
		Blue2: "Green50",
		Blue3: "Green500",

		PrimaryBlue: "Green700",
		PrimaryDisabledColor: "Green200",
		PrimaryColor2: "Green800",
		PrimaryColor3: "Green900",

		SiteHeaderBackground: "Grey50",

		CompanyHeaderBlue1: "Grey50",
		CompanyHeaderBlue2: "Grey200",

		/* LINK */
		LinkNormal: "Blue600",
		LinkHover: "Blue800",
		LinkActive: "Blue600",

		/* Comment */
		CommentActiveColor: "Green600",

		/** custom view */
		CustomViewOptionActiveColor: "Green500",

		/* FULL SCREEN HEADER */
		FullScreenHeaderBackgroundColor: "Grey50",
		FullScreenLogoBackgroundColor: "Grey50",

		/* TEXT */
		TabsTextActive: "Green700",

		/* Button */
		BtnPrimaryFocusedBorderColor: "Green900",
		ButtonSwitchNormalIconStateOnBackgroundColor: "Green700",

		/* BreadCrumb */
		BreadcrumbNormalLinkColor: "Blue600",

		/* CheckBox */
		CheckBoxFocusColor: "Green300",

		/* Text Border */
		TextfieldActiveBorderColor: "PrimaryColor",
		BtnToolbarFocusedBorderColor: "PrimaryColor",

		/* DropDown */
		DropdownSelectActiveBorderColor: "PrimaryColor",

		/* Header */
		LastVisitedIconColor: "Grey50",
		LastVisitedBackgroundColor: "Black400",
		PageHeaderButtonTextColor: "SecondaryText",
		PageHeaderToolbarIconColor: "Black400",
		PageHeaderToolbarHoverColor: "Green700",
		PageHeaderSearchInButtonHoverColor: "Grey100",
		PageHeaderToolbarSeparatorColor: "Grey300",
		PageHeaderSearchScopeBackgroundColor: "White50",
		PageHeaderSearchBlockBackgroundColor: "Grey300",
		CompanyLogoTextColor: "Black50",
		CompanyLogoImageURL: "LightCompanyLogoIconURL",
		ExitFullScreenIconURL: "LightExitFullScreenIconURL",

		/* Table */
		TableCopyBorderColor: "Green600",
		TablePasteBorderColor: "Green600",
		TableNewRowBackgroundColor: "Green100",

		/* Slicer */
		SlicerMetricsBackgroundColor: "Green100",

		/* Chart */
		ChartAreaURL: "ChartAreaGreenURL",
		ChartBarURL: "ChartBarGreenURL",
		ChartColumnURL: "ChartColumnGreenURL",
		ChartDoughnutURL: "ChartDoughnutGreenURL",
		ChartLineURL: "ChartLineGreenURL",
		ChartMsAreaURL: "ChartMsAreaGreenURL",
		ChartMsBarURL: "ChartMsBarGreenURL",
		ChartMsColumnURL: "ChartMsColumnGreenURL",
		ChartMsLineURL: "ChartMsLineGreenURL",
		ChartParetoURL: "ChartParetoGreenURL",
		ChartPieURL: "ChartPieGreenURL",
		ChartStackedAreaURL: "ChartStackedAreaGreenURL",
		ChartStackedBarURL: "ChartStackedBarGreenURL",
		ChartStackedColumnURL: "ChartStackedColumnGreenURL",

		/* Progress bar */
		ProgressBarDeterminateProgressColor: "PrimaryColor",

		HighlightSelected: "Green50"
	};
});